<template>

    <div class="navbar navbar-inverse navbar-fixed-top" role="navigation">

        <div class="container-fluid">

            <div class="navbar-header">

                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">

                    <span class="sr-only">Toggle navigation</span>

                    <span class="icon-bar"></span>

                    <span class="icon-bar"></span>

                    <span class="icon-bar"></span>

                </button>

                <a class="navbar-brand" href="/"><img class="navbar-logo" src="../assets/images/SPARK-logo.png" style="height:42px;filter: invert(100%);"/></a>

            </div>

            <div class="navbar-collapse collapse">

                <ul class="nav navbar-nav navbar-right">

                    <li>

                        <div v-if="this.username!==null" class="btn-group" id="navbar-dropdown">

                            <a class="btn btn-primary" href="/dashboard"><i class="fa fa-user"></i> {{username}}</a>

                            <a class="btn btn-primary dropdown-toggle" @click="logout()" href="#">

                                <i class="fa fa-sign-out"></i>

                            </a>

                        </div>

                        <a v-else id="login-button" href="/login">

                            <button type="button" class="btn btn-primary">Login</button>

                        </a>

                       

 

                   <!-- <li>

                        <a id="login-button" href="/login">

                            <button type="button" class="btn btn-primary">Login</button>

                        </a>

                        -->

                    </li>

                </ul>

            </div>

        </div>

    </div>
    <div class="col-sm-3 col-md-2" style="text-align:center; position: fixed; bottom: 0px; font-size: 9pt; font-weight: 600;background: #2f4154; color:#EEE; z-index: 99999999999999999999999999;padding: 0 10px;"><span style="font-weight:800;">SPARK</span> v.<span id="sparkVersionNumber">1.0.2</span> - ©2024</div>

</template>

 

 

<script>
/* eslint-disable */
 

//{{ this.refreshed ===  false ? loadUser() : null  }}

//const user = '';

export default {

  name: 'NavBar',

  /*props: {

    msg: String

  }*/

   data: function() {

        return {

            user: null,

            username: null

        }

    },

     created() {

      

    },

    methods :  {

        logout() {

             window.sessionStorage.clear();

            this.user = null;

            this.username = null;

            this.$router.push('/login');

           

        }

       

    },

    beforeMount() {
        this.user = window.sessionStorage.getItem("user");

        this.user = JSON.parse(this.user);

        if (null != this.user) {

            this.username = this.user.username;

        }

    },

}

</script>

 

 

<style></style>